import { chakra, Image, Link } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React from 'react';

import type { BannerPlatform } from './types';
import type { AdBannerProviders } from 'types/client/adProviders';

import config from 'configs/app';
import { Skeleton } from 'toolkit/chakra/skeleton';

import AdbutlerBanner from './AdbutlerBanner';
import CoinzillaBanner from './CoinzillaBanner';
// import GetitBanner from './GetitBanner';
import HypeBanner from './HypeBanner';
import SliseBanner from './SliseBanner';

const feature = config.features.adsBanner;

interface Props {
  className?: string;
  isLoading?: boolean;
  platform?: BannerPlatform;
  provider: AdBannerProviders | 'custom'; // Added 'custom' as a new provider option
}

const linkUrl = 'https://cards.emoney.io/';

// Custom banner component
const CustomBanner = () => {
  const router = useRouter();

  // Check if current path is root ("/")
  const isRootPath = router.pathname === '/';

  // Choose image based on current URL
  const banner1 = 'https://pub-3f503cc97e6a45668fbec4d67d6bcb12.r2.dev/Banner_1.png';
  const banner2 = 'https://pub-3f503cc97e6a45668fbec4d67d6bcb12.r2.dev/Banner_2.png';

  const imageUrl = isRootPath ? banner1 : banner2;

  return (
    <Link href={ linkUrl } >
      <Image
        src={ imageUrl }
        alt="Custom Banner"
        w="100%"
        h="auto"
        borderRadius="8px"
        cursor="pointer"
        transition="opacity 0.2s"
        _hover={{ opacity: 0.8 }}
      />
    </Link>
  );
};

const AdBannerContent = ({ className, isLoading, provider, platform }: Props) => {
  const router = useRouter();
  const isRootPath = router.pathname === '/';
  const content = (() => {
    switch (provider) {
      case 'adbutler':
        return <AdbutlerBanner platform={ platform }/>;
      case 'coinzilla':
        return <CoinzillaBanner platform={ platform }/>;
      // case 'getit':
      //   return <GetitBanner platform={platform}/>;
      case 'hype':
        return <HypeBanner platform={ platform }/>;
      case 'slise':
        return <SliseBanner platform={ platform }/>;
      case 'custom':
        return <CustomBanner/>;
      default:
        return <CustomBanner/>;
    }
  })();

  return (
    <Skeleton
      className={ className }
      loading={ isLoading }
      borderRadius="8px" // Fixed: moved borderRadius here to apply to skeleton
      maxW={ isRootPath ? '30%' : '85%' }
      w="100%"
    >
      <CustomBanner/>
    </Skeleton>
  );
};

export default chakra(AdBannerContent);
